<ds-input-file [headline]="title" [description]="dsDescripcion" [state]="$any(dsState)" accept=".pdf,.jpg,.jpeg"
  [multiple]="false" [disabled]="false" [showIcon]="true" [(fileName)]="selectedFileName" [showReviewButton]="true"
  [showDeleteButton]="true" uploadLabel="Cargar documento" successLabel="Seleccionado" reviewLabel="Revisar"
  deleteLabel="Eliminar" retryLabel="Reintentar" (reviewRequested)="reviewDocument()"
  (filesSelected)="setDocumentType(); onFileSelectedDS($event)" (deleteRequested)="confirmDeleteDocument()" (retryRequested)="retryUpload()" />



<ds-modal-bottom-sheet [visible]="sheetVisible" title="¿Quieres eliminar el documento?"
  description="Vas a eliminar el documento, tendrás que cargarlo nuevamente para continuar." [maxWidth]="400"
  [dismissOnBackdropClick]="true" [showIcon]="true" iconName="WarningFill"
  iconColor="var(--ds-foundation-colors-role-warning-300)" (dismissed)="sheetVisible = false">
  <div ds-modal-bottom-sheet-action>
    <ds-button-v2 label="Eliminar" (clicked)="delDocument()">
    </ds-button-v2>
    <ds-button-v2 label="Mantener Documento" emphasis="secondary" (clicked)="sheetVisible = false">
    </ds-button-v2>
  </div>
</ds-modal-bottom-sheet>

<ds-content-sheet
  [visible]="sheetReviewVisible"
  title="{{ title }}"
  [maxWidth]="900"
  [dismissOnBackdropClick]="true"
  (dismissed)="sheetReviewVisible = false">

  <div class="document-preview">
    <img *ngIf="previewType === 'image' && previewUrl" class="document-preview__image" [src]="previewUrl"
      [alt]="'Vista previa de ' + title" />


    <ng-container *ngIf="previewType === 'pdf' && previewResourceUrl">
      <iframe class="document-preview__pdf" [src]="previewResourceUrl" [title]="'Vista previa de ' + title"></iframe>
      
    </ng-container>

    <p *ngIf="!previewUrl" class="ds-text-body-s-regular">
      La vista previa no está disponible. Vuelve a seleccionar el documento para revisarlo.
    </p>
  </div>
</ds-content-sheet>

<span *ngIf="status === 'without_uploading_document' && errorCustomFile" class="text-error">
  Hubo un error al seleccionar este documento. Por favor, verifica el tipo o el
  tamaño del archivo.
</span>